import { Component, OnInit, ElementRef, Input, ViewChild, Directive, HostListener } from '@angular/core';
import { MainService } from '../../../shared/services/main.service'
import { DatePipe } from '@angular/common'
import { DataService } from "../../services/data.service"
import { CaMasterService } from "../../services/accounts/ca-master.service"
import { InPurchasesService } from "../../services/inventory/in-purchases.service"
import { RptFiterComponent } from "../../../shared/component/rpt-fiter/rpt-fiter.component"
import { InReportService } from "../../services/inventory/in-report.service"
import { VchrprintComponent } from "../../../shared/component/vchrprint/vchrprint.component"
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from '../../../../environments/environment';
import { DialogService } from "../dialog";
import { DomSanitizer } from "@angular/platform-browser";
import { DialogComponent } from "../dialog/dialog.component";

export interface ConfirmModel112 {
  title: string;
  Items: any;
  SupId: any;
}

@Component({
  selector: 'app-chequeprint',
  templateUrl: './chequeprint.component.html',
  styleUrls: ['./chequeprint.component.css']
})

export class ChequeprintComponent extends DialogComponent<ConfirmModel112, boolean>
  implements ConfirmModel112, OnInit {
  @Input() Items: any;
  @Input() title: string;
  @Input() model = {
    Account: 0,
    ChequeNo: "",
    ChequeDate: new DatePipe("en-US").transform(new Date, 'dd-MMM-yyyy'),
    Beneficiary: "",
    Amount: 0,
    isaccountpayee: true,
    ischequedate: true
  }
  @Input() SupId: any;
  @Input() Supplier: any;
  @Input() language: string = "en-us";
  @Input() width: number = 100;
  @Input() height: number = 100;
  @Input() toolbar: string = "true";
  constructor(dialogService: DialogService, private ds: DataService, private ca: CaMasterService, private rp: InReportService, private route: ActivatedRoute, private ips: InPurchasesService) {
    super(dialogService);
    if (this.Items) {
      this.model = this.Items;
      this.model.ChequeDate = new DatePipe("en-US").transform(this.model.ChequeDate, 'dd-MMM-yyyy');
    }
    if (this.SupId) {
      this.Supplier = this.SupId;
    }
  }

  rptList: any = [];
  loading: boolean = false;
  Caption: string = ""
  ///////////////// SSRS ////////////////
  parametersList: any;
  reportServer: string = environment.reportUrl;
  reportUrl: string;
  showParameters: string = "true";
  parameters: any = {};
  Access: any;
  Bledger = [];
  isLoaded: boolean = false;
  LedgerId: number;
  cancelBtn: boolean = true;
  amountinwords: any;
  date: any;
  ngOnInit() {
    this.ds.ComponentName = "Cheque Print";
    this.Access = this.ds.Access["Cheque Print"];
    this.loading = false
    document.getElementById("BankName").focus();
    if (this.Items) {
      this.model = this.Items;
      this.cancelBtn = false;
    }
    if (this.SupId) {
      this.Supplier = this.SupId;
      if (this.Supplier != 0) {
        this.getSupplier();
        this.cancelBtn = false;
      }
    }
    if (this.model) {
      this.getBankLedger();
    } else {
      this.close()
      this.cancelBtn = true;
    }
    this.model.isaccountpayee = true;
    this.model.ischequedate = true;
  }

  getBankLedger() {
    var VFun = {
      GroupId: this.ds.Settings.BankHead,
      RequestDataList: {
        Start: 0,
        FiterText: "",
        Limit: this.ds.Settings.MaxLimit,
        ItemTypeId: this.ds.Settings.ItemTypeId,
        CAType: this.ds.Settings.CAType
      }
    };

    this.ca.GetLedgerByMainGroupId(VFun).subscribe(res => {
      if (res.Success) {
        this.Bledger = [];
        var a = 0;
        for (let i of res.data) {
          this.Bledger.push({
            Id: i.Id,
            Name: i.Code + " - " + i.Name,
            NameOnly: i.Name
          });
        }
        this.model.Account = this.Bledger[0].Id;
      }
    });
  }
  getSupplier() {
    var FilterData: any = {
      Id: this.Supplier,
      CATypeId: this.ds.Settings.CAType
    };
    this.ips.getSupplierById(FilterData).subscribe(
      res => {
        if (res.Success) {
          this.model.Beneficiary = res.data.Name
        }
      }

    )
  }
  loadReport() {
    if (this.model.Amount != 0 && this.model.Amount != null) {
      if (this.model.ChequeNo != "" && this.model.ChequeNo != null && this.model.ChequeNo != "0") {
        if (this.model.Beneficiary != "" && this.model.Beneficiary != null) {
          if (this.loading) {
            this.loading = false
          }
          this.isLoaded = true;
          var amt = parseFloat(this.model.Amount.toString()).toFixed(environment.noofdecimal);
          var t = "Cheque Print";
          var url = environment.reportUrl;
          var inwords = {
            Amount: amt,
            IntegerPart: this.ds.Settings.IntegerPartCaption,
            DecimalPart: this.ds.Settings.DecimalPartCaption,
          }
          this.rp.getChequeprintAmountinWords(inwords).subscribe(res => {
            this.amountinwords = res.data;
            this.rp.getChequeprint(this.model.Account).subscribe(res => {
              this.reportUrl = res.data;
              this.isLoaded = false;
              var name: string;
              if (this.model.isaccountpayee == true) {
                name = "Account Payee";
              }
              else {
                name = "";
              }
              if (this.model.ischequedate == true) {
                this.date = this.model.ChequeDate;
              }
              else {
                this.date = "";
              }
              this.loading = true;
              this.parameters = { ChDate: new DatePipe("en-US").transform(this.date, 'dd-MMM-yyyy'), Name: this.model.Beneficiary, Amount: amt, AmountInWords: this.amountinwords, ischqdate: 0, isaccpayee: 0, CNo: 0, accountpayee: name }

            });
          });
        }
        else {
          alert("Please enter valid Beneficiary")
          document.getElementById("beneficiary").focus();
        }
      }
      else {
        this.parameters = {}
        alert("Please enter valid Cheque Number")
        document.getElementById("chqno").focus();
      }
    }
    else {
      this.parameters = {}
      alert("Please enter valid Amount");
      document.getElementById("amount").focus();
    }
  }
  clear() {
    this.getBankLedger();
    this.model.Amount = 0;
    this.model.Beneficiary = "";
    this.model.ChequeDate = new DatePipe("en-US").transform(new Date, 'dd-MMM-yyyy');
    this.model.ChequeNo = "";
    this.model.isaccountpayee = true;
    this.model.ischequedate = true;
    this.isLoaded = false;
    this.loading = false;
    document.getElementById("BankName").focus();
  }
  Change(e) {
    if (e == 1) {
      this.model.isaccountpayee = !this.model.isaccountpayee;
    }
    if (e == 2) {
      this.model.ischequedate = !this.model.ischequedate;
    }
  }
  Cancel() {
    this.close();
  }
  beneficiaryKeydown(e) {
    if (e.keyCode == 13 && e.which == 13) {
      document.getElementById("chqno").focus();
    }
  }
  chequenoKeydown(e) {
    if (e.keyCode == 13 && e.which == 13) {
      document.getElementById("amount").focus();
    }
  }
  amountKeydown(e) {
    if (e.keyCode == 13 && e.which == 13) {
      document.getElementById("chqdate").focus();
    }
  }
  selectAll(e) {
    e.target.select()
  }

  saveEditAccessPremission(Access: any, edit: boolean): boolean {
    Access = this.ds.Access["Cheque Print"];
    if (edit) {
      return !Access.edit;
    }
    else {
      return !Access.save;
    }
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/chequeprint/chequeprint.component.ts